/* @flow */
import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'

class ExportButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  
  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  }

  handleExportClick = (event) => {
    const { handleExportLayerRequest, onClick } = this.props;

    const format = event.target.innerText

    onClick({ format })
    this.handleClose()
  }
  
  render() {
    let { anchorEl } = this.state;
      const { hasValidToken, handleExportLayerRequest } = this.props;

    // Close popup if user has token
    let buttonText = 'Export';
    if (hasValidToken) {
      anchorEl = null;
      buttonText = 'Logged In';
    }
    return (
      <div>        
          <IconButton
              key='exportButton'
              onClick={this.handleClick}
              aria-label='Export data'
          >
              <CloudDownloadIcon />
          </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Button onClick={this.handleExportClick} >
                GeoTIFF
            </Button>
          <Button onClick={this.handleExportClick} >
                GeoJSON
          </Button>            
        </Popover>
      </div>
    );
  }
}

// ExportButton.propTypes = {
//   hasValidToken: PropTypes.bool,
//   setHasValidToken: PropTypes.func
// };

// const mapStateToProps = state => ({
//   hasValidToken: authSelectors.getHasValidToken(state)
// });

// const mapDispatchToProps = { setHasValidToken };
// export default connect(mapStateToProps, mapDispatchToProps)(Login);
export default ExportButton



// WEBPACK FOOTER //
// ./src/components/ExportButton.js